import React, { useState, useEffect, useCallback } from 'react';
import Accordion from 'b2b-ui-components-lib/lib/components/accordion';
import Checkbox from 'b2b-ui-components-lib/lib/components/checkbox';
import { DEFAULT_FORM_CONFIG, PO_FILE_SCHEMA } from './formConfig';
import { FormBuilder, IFORM } from '../FormBuilder';
import './index.scss';
import FileUpload from 'dedicated/components/summary/fileUpload/fileUpload';
import { FILE_MAX_SIZE_MSG } from 'common/constants/app.constants';

type Props = {
  disabled: boolean;
  title?: string;
};

export const PurchaseOrder = ({ disabled, title = 'Purchase Order Details' }: Props) => {
  const [accordionMetadata, setAccordionMetadata] = useState({ isValidated: false, isEditable: false });
  const onSubmit = useCallback((form: { isValid: boolean; values: IFORM }) => {
    setAccordionMetadata({ ...accordionMetadata, isValidated: form.isValid });
  }, []);

  const onFieldChange = useCallback((field: string, value: any) => {
    console.log('values', field, value);
  }, []);

  const onFileUpload = () => {};

  return (
    <React.Fragment>
      <Accordion title={title} autoScrollOnExpand={false} isExpanded={true} isValidated={accordionMetadata.isValidated} isEditable={accordionMetadata.isEditable}>
        <div className="accordion_body">
          <Checkbox disabled={true} checked={true} onChange={() => {}}>
            <span className="check_text">Add PO details in my bill</span>
          </Checkbox>
          {true && (
            <div className="order_details_form">
              <div className="row field_row">
                <div className="flg-lg-12 flg-md-12">
                  <div className="form_area">
                    <div className="row">
                      <FormBuilder formConfig={DEFAULT_FORM_CONFIG} onSubmit={onSubmit} onChange={onFieldChange}></FormBuilder>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {true && (
            <div className={disabled ? 'accordion_footer disabled' : 'accordion_footer'}>
              <FileUpload
                onFileUploadSuccess={onFileUpload}
                label="Upload Purchase Order Document"
                supportedLabel="Supported file format is .PDF, .PNG, .JPG"
                limitLabel={FILE_MAX_SIZE_MSG}
                fileSchema={PO_FILE_SCHEMA}
                isFileHaveValue={false}
                fileArray={[]}
                isOrderConfirmation={disabled}
                type={''}
                multiple={true}
              ></FileUpload>
            </div>
          )}
        </div>
      </Accordion>
    </React.Fragment>
  );
};

export default PurchaseOrder;
